import { useTranslation } from 'react-i18next';

export type TranslationFnMap<T extends string = string> = Record<
  T,
  () => string
>;

export const useErrorTranslator = <T extends TranslationFnMap>(mapping: T) => {
  const { t } = useTranslation();

  const translateError = (code: string): string => {
    return mapping[code]?.() ?? t(code);
  };

  return translateError;
};
